import type { AiFredNewMessageSocketEvent } from "./aifred-new-message.socket-event";
import {
    AiFredSocketEventNamespace,
    AiFredSocketEventTypeNames,
} from "./aifred-socket-event-type-name";

type AiFredSocketEvent = AiFredNewMessageSocketEvent;

type AiFredSocketEventType = AiFredSocketEvent["type"];

const AiFredSocketEventTypes = AiFredSocketEventTypeNames.map(
    name => `${AiFredSocketEventNamespace}:${name}`,
) as AiFredSocketEventType[];

export { AiFredSocketEventTypes };
export type { AiFredSocketEvent, AiFredSocketEventType };
